import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-559d856b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stake-staked-overview" }
const _hoisted_2 = { class: "stake-staked-overview__block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Total staked", -1))
const _hoisted_4 = { class: "stake-staked-overview__block" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Overall earnings", -1))
const _hoisted_6 = { class: "stake-staked-overview__block" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Overall yield", -1))

import { nativeToken } from "@/stores";


export default /*#__PURE__*/_defineComponent({
  __name: 'stake-staked-overview',
  props: {
  total: {
    type: Number,
    default: 0,
  },
  earnings: {
    type: Number,
    default: 0,
  },
  yield: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h5", null, [
        _createTextVNode(_toDisplayString(_ctx.$filters.cryptoCurrencyFormat(__props.total)) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(_unref(nativeToken).symbol), 1)
      ]),
      _createElementVNode("h6", null, _toDisplayString(_ctx.$filters.currencyFormat(__props.total * _unref(nativeToken).price?.toNumber(), "USD")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("h5", null, [
        _createTextVNode(_toDisplayString(_ctx.$filters.cryptoCurrencyFormat(__props.earnings)) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(_unref(nativeToken).symbol), 1)
      ]),
      _createElementVNode("h6", null, _toDisplayString(_ctx.$filters.currencyFormat(
            __props.earnings * _unref(nativeToken).price?.toNumber(),
            "USD"
          )), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("h5", null, _toDisplayString(_ctx.$filters.cryptoCurrencyFormat(__props.yield)) + "%", 1)
    ])
  ]))
}
}

})